module.exports = __webpack_public_path__ + "static/media/menu-analytics-active.afaa2ad2.svg";